export default __webpack_public_path__ + "static/subscribe-star-logo-7a0c2163759bef0a2fbaa4329bad959e.png";